import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { BankContactDetail } from "../components/BankContactDetail/BankContactDetail";
import { Login } from "../components/Login/Login/Login";
import { CreateAccount } from "../components/Login/CreateAccount/CreateAccount";
import { ForgetPassword } from "../components/Login/ForgetPassword/ForgetPassword";
import { ChangePassword } from "../components/Login/ChangePassword/ChangePassword";
import { AlreadyRegistered } from "../components/Login/AlreadyRegistered/AlreadyRegistered";
import { CodeAuthentication } from "../components/Login/CodeAuthentication/CodeAuthentication";
import VendorDetails from "../components/VendorDetails/VendorDetails";
import { PurchaseOrders } from "../components/PO/PurchaseOrders/PurchaseOrders";
import Sidebar from "../components/Sidebar/Sidebar";
import Header from "../components/Header/Header";
import Navbar from "../components/Navbar1/Navbar";
import Footer from "../components/Footer/Footer";
import { BillsPayment } from "../components/BillsPayment/BillsPayment";
import Profile from "../components/Profile/Profile";
import AllRFQs from "../components/AllRfqs/AllRFQs";
import ApplyNowRFQs from "../components/ApplyNowRFQs/ApplyNowRFQs";
import "./routing.css";
import SubmittedQoutes from "../components/SubmittedQuotes/SubmittedQoutes";
import ViewRfq from "../components/ViewRFQ/ViewRfq";
import PrivateRoute from "../Utils/PrivateRoute";
import { useSelector } from "react-redux";
import RegistrationConfirm from "../components/Login/Confimation/RegistrationConfirm";
import NavbarStratum from "../components/NAVBAR_STRATUM/NavbarStratum";
import { PRODUCT } from "../Utils/variables";
import CreateBill from "../components/BillsPayment/CreateBill";
export const Routing = () => {
  const [isLogged, setIsLogged] = useState(false);
  const { isLogin, vendorId } = useSelector((state) => state.auth);
  const LoginRenderingHandler = (data) => {
    setIsLogged(isLogin);
  };

  return (
    <div className={isLogin ? "routingMainContainer" : ""}>
      {isLogin && <Sidebar RenderHandler={LoginRenderingHandler} />}
      {!isLogin && <Navbar />}
      <Routes>
        <Route element={<PrivateRoute isLogged={isLogin} />}>
          <Route path="*" element={<Login />} />

          <Route path={"/viewrfq"} element={<ViewRfq />}></Route>
          <Route path={"/quotation"} element={<ApplyNowRFQs />}></Route>
          <Route path={"/profile"} element={<Profile />}></Route>
          <Route path={"/purchaseorder"} element={<PurchaseOrders />} />
          <Route path={"/billspayment"} element={<BillsPayment />} />
          <Route path={"/createbill"} element={<CreateBill />} />
          <Route path={"/rfqs"} element={<AllRFQs />} />
          <Route path={"/submittedqoutes"} element={<SubmittedQoutes />} />
        </Route>
        <Route
          path={"/login"}
          element={<Login RenderHandler={LoginRenderingHandler} />}
        ></Route>

        <Route path={"*"} element={<Login />}></Route>
        <Route path={"/createaccount"} element={<CreateAccount />}></Route>
        <Route
          path={"/registrationsuccess"}
          element={<RegistrationConfirm />}
        ></Route>
        <Route path={"/forgetpassword"} element={<ForgetPassword />}></Route>
        <Route
          path={"/alreadyregistered"}
          element={<AlreadyRegistered />}
        ></Route>
        <Route
          path={"/codeauthentication"}
          element={<CodeAuthentication />}
        ></Route>
        {/* <Route
          path={"/bankdetails"}
          element={<BankContactDetail />}
        ></Route> */}
        <Route path={"/changepassword"} element={<ChangePassword />} />
        <Route path={"/vendordetails"} element={<VendorDetails />}></Route>
      </Routes>
      {!isLogin &&
        process.env.REACT_APP_PRODUCT !== "STRATUM" &&
        process.env.REACT_APP_PRODUCT !== "DANUBE" && <Footer />}
    </div>
  );
};
